export const validation = {
  selectTagType: 'Please select tag type',
};
